import * as React from 'react';
import { Text, Card, CardHeader } from "@fluentui/react-components";
import { PersonSettings20Regular } from '@fluentui/react-icons';
import { ControlPanelNavigation } from './control-panel-navigation.js';

export const Account = () => {
    return <>
        <div className='control-panel-layout'>
            <aside className="sidenav">
                <ControlPanelNavigation />
            </aside>
            <div className="main-cards">
                <Card size='large'>
                    <CardHeader image={<PersonSettings20Regular />} header={<Text weight="semibold">Account</Text>} />
                </Card>
            </div>
        </div>
    </>;
};